export default "__VITE_ASSET__Dys7uwJ3__"